module.exports = __webpack_public_path__ + "img/foto 1 Arranquio de mudas.06e33170.webp";